import { useAppStateMachine } from '@/components/providers/app-state-machine-provider';
import { useClerk } from '@clerk/react-router';
import { useNavigate } from 'react-router-dom';

const useSignOut = () => {
    const { send } = useAppStateMachine();
    const { user } = useClerk();
    const navigate = useNavigate();

    const signOutFn = async () => {
        if (user) {
            send({ type: 'LOGOUT' });
        } else {
            navigate('/');
        }
    };

    return {
        signOutFn,
    };
};

export { useSignOut };
